export const r3 = (x) => Math.round((Number(x) || 0) * 1000 + Number.EPSILON) / 1000;

export const money = (x, cur = "TND", lang = "fr") => {
  const s = new Intl.NumberFormat("fr-FR", { minimumFractionDigits: 3, maximumFractionDigits: 3 }).format(r3(x));
  if (cur !== "TND") return `${s} ${cur}`;
  return `${s} ${lang === "ar" ? "د.ت" : "DT"}`;
};

export const dmy = (iso) => {
  if (!iso) return "—";
  const [y, m, d] = iso.slice(0, 10).split("-");
  return `${d}/${m}/${y}`;
};

export const dmyTime = (iso) => (iso ? `${dmy(iso)} ${iso.slice(11, 16)}` : "—");

export const todayIso = () => new Date().toISOString().slice(0, 10);

export function computeTotals(lines, gdp = 0, stamp = 0) {
  const ls = lines.map((l) => ({ ...l, total_ht: r3((+l.qty || 0) * (+l.unit_price || 0) * (1 - (+l.discount_pct || 0) / 100)) }));
  const lines_ht = r3(ls.reduce((s, l) => s + l.total_ht, 0));
  const gd = r3((lines_ht * gdp) / 100);
  const ht = r3(lines_ht - gd);
  const bases = {};
  ls.forEach((l) => { bases[+l.vat_rate || 0] = (bases[+l.vat_rate || 0] || 0) + l.total_ht; });
  const vb = Object.entries(bases).sort((a, b) => b[0] - a[0])
    .map(([rate, b]) => ({ rate: +rate, base: r3(b * (1 - gdp / 100)), amount: r3((b * (1 - gdp / 100) * rate) / 100) }));
  const vat = r3(vb.reduce((s, v) => s + v.amount, 0));
  return { lines: ls, totals: { lines_ht, global_discount: gd, ht, vat_breakdown: vb, vat, stamp: r3(stamp), ttc: r3(ht + vat + stamp) } };
}

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Erreur";
  if (typeof d === "string") return d;
  if (d.errors) return `${d.message} : ${d.errors.join(" · ")}`;
  if (Array.isArray(d)) return d.map((x) => x.msg).join(" · ");
  return JSON.stringify(d);
};

export const MF_RE = /^\d{7}[A-Z][ABDNP][MPCNE]\d{3}$/;
export const validMf = (v) => MF_RE.test((v || "").toUpperCase().replace(/[\s/.-]/g, ""));
